/* DRUM TOASTER page: the lever player.
   The stage is the plugin's own face (dt-face.js, a port of ToasterEditor::paint).
   Every stem of the current loop plays in sync (raw + 4 lever stops per flavor);
   the lever does an equal-power crossfade between the two nearest stops, so the
   visitor hears the real rendered plugin at any position. Flavor switches keep
   the playhead; BYPASS on the toaster plays the raw loop; EXTRA (the ring on the
   face or the extra switch) swaps in that flavor's EXTRA stems. Stems are pre-rendered
   by scripts/plugin_page/render_audio.py. */
(function () {
  var root = document.querySelector('[data-dt-player]');
  if (!root) return;
  var BASE = root.getAttribute('data-base') || '';
  var PREFIX = root.getAttribute('data-prefix') || '';
  // the version stamp makes Shopify's CDN serve the files of the current upload (without it, stale copies)
  var V = root.getAttribute('data-v') || '';
  var url = function (f) { return BASE + PREFIX + f + (V ? '?v=' + V : ''); };

  var FACE_NAMES = ['Butter', 'Honey', 'Jam', 'Charred'];   // face pill order
  var loading = root.querySelector('.dt-loading');
  var matchBox = root.querySelector('[data-dt-match]');
  var extraBox = root.querySelector('[data-dt-extra]');

  var man = null, ctx = null, master = null, analyser = null, outGain = null, limiter = null, outVal = 0.5;
  var cache = {};                        // file -> AudioBuffer
  var voices = [];                       // [{src, gain, lufs}] for current loop+flavor (index 0 = raw)
  var loopIdx = 0, flavor = 'Butter', t = 0.5, bypass = false, extra = false, playing = false, startAt = 0, offset = 0;

  // transient flash for the lever's amber strip (the plugin's pilot lamp)
  var envFast = 0, envSlow = 0, buf = null;
  function flash() {
    if (!playing || !analyser) return 0;
    if (!buf) buf = new Float32Array(analyser.fftSize);
    analyser.getFloatTimeDomainData(buf);
    var pk = 0; for (var i = 0; i < buf.length; i++) { var a = Math.abs(buf[i]); if (a > pk) pk = a; }
    envFast = Math.max(pk, envFast * 0.6);
    envSlow = envSlow * 0.97 + pk * 0.03;
    var r = envFast / (envSlow + 1e-4);
    return r > 1.6 && pk > 0.05 ? Math.min(1, (r - 1.6) * 0.8) : 0;
  }

  var face = window.DTFace(root.querySelector('.dt-gui'), {
    bg: root.getAttribute('data-face-bg'),
    logo: root.getAttribute('data-face-logo'),
    lever: t,
    flash: flash,
    onLever: function (v, start) {
      t = v; mix();
      if (start) { var w = root.closest('.dt-play-wrap'); if (w) w.classList.add('dt-lh-done'); }
      if (start && !playing && !root.dataset.touched) { root.dataset.touched = '1'; play(); }
    },
    onOutput: function (v) {
      outVal = v;
      applyOut();
    },
    onTip: function (kind) {
      var face = root.querySelector('.dt-face'); if (!face) return;
      var tip = face.querySelector('.dt-tip');
      if (!tip) { tip = document.createElement('div'); tip.className = 'dt-tip'; face.appendChild(tip); }
      var what = { mix: 'mix', os: 'oversampling', preset: 'presets', input: 'input' }[kind] || 'that';
      tip.textContent = what + (kind === 'preset' ? ' work' : ' works') + ' in the plugin. try it in your DAW';
      tip.classList.add('on'); clearTimeout(tip._t); tip._t = setTimeout(function () { tip.classList.remove('on'); }, 2200);
    },
    onFlavor: function (i) {
      var name = FACE_NAMES[i];
      swap(function () { flavor = name; }, true);
      syncPills();
    },
    onBypass: function (on) { bypass = on; mix(); applyOut(); },
    onExtra: function (on) { setExtra(on); }
  });

  // EXTRA = the same flavor's EXTRA stems (lever 0 stays the raw loop: the plugin is clean there either way)
  function setExtra(on) {
    if (on === extra) return;
    swap(function () { extra = on; }, true);
    face.setExtra(on);
    if (extraBox) extraBox.checked = on;
  }

  // ---------- crossfade ----------
  function mix() {
    if (!voices.length || !ctx) return;
    var stops = man.stops, n = stops.length, i = 0;
    while (i < n - 2 && t > stops[i + 1]) i++;
    var k = (t - stops[i]) / (stops[i + 1] - stops[i]);
    k = Math.min(1, Math.max(0, k));
    // match loudness: meet in the middle. the raw loop comes UP as far as it can without clipping (its peak to -1 dBFS),
    // every toasted version comes down to that level. matching down to the raw loop alone made the page very quiet.
    var ref = voices[0].lufs + (voices[0].peak != null ? Math.max(0, -1 - voices[0].peak) : 0), now = ctx.currentTime;
    for (var j = 0; j < voices.length; j++) {
      var g = bypass ? (j === 0 ? 1 : 0) : j === i ? Math.cos(k * Math.PI / 2) : j === i + 1 ? Math.sin(k * Math.PI / 2) : 0;
      if (matchBox && matchBox.checked && voices[j].lufs != null) g *= Math.pow(10, (ref - voices[j].lufs) / 20);
      voices[j].gain.gain.setTargetAtTime(g, now, 0.012);
    }
  }

  // OUTPUT, as in the plugin: knob centre = 0 dB (-24 .. +6 dB), and bypass skips it (bypass = the raw input, untouched)
  function outLin() { return bypass ? 1 : Math.pow(10, (outVal < 0.5 ? -48 * (0.5 - outVal) : 12 * (outVal - 0.5)) / 20); }
  function applyOut() { if (outGain) outGain.gain.setTargetAtTime(outLin(), ctx.currentTime, 0.02); }

  // ---------- loading ----------
  function load(file) {
    if (cache[file]) return Promise.resolve(cache[file]);
    return fetch(url(file)).then(function (r) { if (!r.ok) throw new Error(file); return r.arrayBuffer(); })
      .then(function (ab) { return new Promise(function (res, rej) { ctx.decodeAudioData(ab, res, rej); }); })
      .then(function (buf) { cache[file] = buf; return buf; });
  }
  function filesFor(li, fl) {
    var L = man.loops[li];
    return [L.dry].concat(extra && L.extra ? L.extra[fl] : L.stems[fl]);
  }
  function preloadLoop(li) {
    var L = man.loops[li], all = [L.dry];
    man.flavors.forEach(function (f) { all = all.concat(L.stems[f], L.extra ? L.extra[f] : []); });
    return Promise.all(all.map(load));
  }

  // ---------- transport ----------
  function stopVoices(fade) {
    var now = ctx ? ctx.currentTime : 0;
    voices.forEach(function (v) {
      try {
        v.gain.gain.setTargetAtTime(0, now, fade ? 0.02 : 0.001);
        v.src.stop(now + (fade ? 0.12 : 0.01));
      } catch (e) {}
    });
    voices = [];
  }
  function position() {
    if (!playing) return offset;
    var dur = man.loops[loopIdx].seconds;
    return ((ctx.currentTime - startAt) % dur + dur) % dur;
  }
  function startVoices(pos) {
    var files = filesFor(loopIdx, flavor);
    var when = ctx.currentTime + 0.03;
    voices = files.map(function (f) {
      var src = ctx.createBufferSource(); src.buffer = cache[f]; src.loop = true;
      var gain = ctx.createGain(); gain.gain.value = 0;
      src.connect(gain); gain.connect(master);
      src.start(when, pos);
      return { src: src, gain: gain, lufs: man.lufs ? man.lufs[f] : null, peak: man.peak_db ? man.peak_db[f] : null };
    });
    startAt = when - pos;
    mix();
  }
  function setLoading(on) { loading.classList.toggle('on', on); }

  // iPhone: everything that unlocks audio has to happen inside the tap itself, before any await.
  //  1. resume the context, 2. start a one-sample silent buffer, 3. play a silent <audio> element, which moves
  //  the page onto the media channel (the ringer switch and some iOS versions otherwise keep Web Audio silent).
  var SILENCE = 'data:audio/mpeg;base64,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', silentEl = null;
  function unlock() {
    ensureCtx();
    if (ctx.state !== 'running') { try { ctx.resume(); } catch (e) {} }
    try { var b = ctx.createBufferSource(); b.buffer = ctx.createBuffer(1, 1, 22050); b.connect(ctx.destination); b.start(0); } catch (e) {}
    try {
      if (!silentEl) { silentEl = new Audio(SILENCE); silentEl.loop = true; silentEl.setAttribute('playsinline', ''); silentEl.volume = 0.01; }
      var pr = silentEl.play(); if (pr && pr.catch) pr.catch(function () {});
    } catch (e) {}
  }
  // iOS parks the context as "interrupted" after a call, Siri or the app going to the background: wake it on return
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && ctx && playing && ctx.state !== 'running') { try { ctx.resume(); } catch (e) {} }
  });

  function play() {
    unlock();
    setLoading(true);
    return Promise.all(filesFor(loopIdx, flavor).map(load)).then(function () {
      setLoading(false);
      startVoices(offset);
      playing = true;
      root.classList.add('dt-playing');
      waveKick();
      preloadLoop(loopIdx).catch(function () {});
    }).catch(function () { setLoading(false); loading.textContent = 'audio failed to load'; loading.classList.add('on'); });
  }
  function pause() {
    if (silentEl) try { silentEl.pause(); } catch (e) {}
    offset = position();
    stopVoices(true);
    playing = false;
    root.classList.remove('dt-playing');
    drawWave();
  }
  function swap(changeFn, keepPos) {
    var pos = keepPos ? position() : 0;
    changeFn();
    if (!playing) { offset = pos; drawWave(); return; }
    setLoading(true);
    Promise.all(filesFor(loopIdx, flavor).map(load)).then(function () {
      setLoading(false);
      pos = keepPos ? position() : 0;
      stopVoices(true);
      startVoices(pos);
      preloadLoop(loopIdx).catch(function () {});
    });
  }

  function ensureCtx() {
    if (ctx) return;
    // iOS 17+: without this a phone on silent plays Web Audio muted
    try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch (e) {}
    var AC = window.AudioContext || window.webkitAudioContext;
    ctx = new AC();
    master = ctx.createGain(); master.gain.value = 0.9;
    // OUTPUT knob: clean volume after everything (knob centre = 0 dB, -24 dB .. +6 dB), then a safety limiter so
    // turning it up can't crackle
    outGain = ctx.createGain(); outGain.gain.value = outLin();
    limiter = ctx.createDynamicsCompressor();
    limiter.threshold.value = -1; limiter.knee.value = 0; limiter.ratio.value = 20; limiter.attack.value = 0.002; limiter.release.value = 0.08;
    master.connect(outGain); outGain.connect(limiter);
    analyser = ctx.createAnalyser(); analyser.fftSize = 1024;
    limiter.connect(analyser); analyser.connect(ctx.destination);
  }

  // ---------- playbar waveform: the raw loop's shape, played part in butter, tap or drag to jump ----------
  var wave = root.querySelector('.dt-wave'), waveRaf = 0;
  function drawWave() {
    if (!wave || !man) return;
    var dpr = window.devicePixelRatio || 1, w = wave.clientWidth, h = wave.clientHeight;
    if (!w || !h) return;
    if (wave.width !== Math.round(w * dpr)) { wave.width = Math.round(w * dpr); wave.height = Math.round(h * dpr); }
    var g = wave.getContext('2d'); g.setTransform(dpr, 0, 0, dpr, 0, 0); g.clearRect(0, 0, w, h);
    var raw = man.loops[loopIdx].wave || [], n = raw.length; if (!n) return;
    var pk = raw.map(function (_, i) {   // 5-point average: a smooth outline, not every hit's spike
      var a = 0, c = 0; for (var k = -2; k <= 2; k++) if (raw[i + k] != null) { a += raw[i + k]; c++; } return a / c;
    });
    var mid = h / 2, amp = h / 2 - 2;
    // smooth mirrored envelope through the peaks (midpoint quadratic curves)
    var path = new Path2D(), xs = function (i) { return i / (n - 1) * w; }, ys = function (i) { return Math.max(1, Math.pow(pk[i], 0.7) * amp); };
    path.moveTo(0, mid - ys(0));
    for (var i = 1; i < n; i++) path.quadraticCurveTo(xs(i - 1), mid - ys(i - 1), (xs(i - 1) + xs(i)) / 2, mid - (ys(i - 1) + ys(i)) / 2);
    path.lineTo(w, mid - ys(n - 1)); path.lineTo(w, mid + ys(n - 1));
    for (var j = n - 2; j >= 0; j--) path.quadraticCurveTo(xs(j + 1), mid + ys(j + 1), (xs(j + 1) + xs(j)) / 2, mid + (ys(j + 1) + ys(j)) / 2);
    path.lineTo(0, mid + ys(0)); path.closePath();
    var frac = position() / man.loops[loopIdx].seconds, px = frac * w;
    g.fillStyle = 'rgba(240,237,227,.28)'; g.fill(path);
    g.save(); g.beginPath(); g.rect(0, 0, px, h); g.clip(); g.fillStyle = '#d6a24e'; g.fill(path); g.restore();
    g.fillStyle = '#f0ede1'; g.fillRect(Math.min(w - 2, Math.max(0, px - 1)), 0, 2, h);
  }
  function waveLoop() { drawWave(); waveRaf = playing ? requestAnimationFrame(waveLoop) : 0; }
  function waveKick() { if (!waveRaf) waveRaf = requestAnimationFrame(waveLoop); }
  function seek(frac) {
    if (!man) return;
    var pos = Math.min(0.999, Math.max(0, frac)) * man.loops[loopIdx].seconds;
    if (playing && voices.length) { stopVoices(true); startVoices(pos); } else offset = pos;
    drawWave();
  }
  if (wave) {
    var seeking = false, fracAt = function (e) { var r = wave.getBoundingClientRect(); return (e.clientX - r.left) / r.width; };
    wave.addEventListener('pointerdown', function (e) { seeking = true; wave.setPointerCapture(e.pointerId); seek(fracAt(e)); });
    wave.addEventListener('pointermove', function (e) { if (seeking && !playing) seek(fracAt(e)); });
    ['pointerup', 'pointercancel'].forEach(function (ev) { wave.addEventListener(ev, function (e) { if (seeking && playing) seek(fracAt(e)); seeking = false; }); });
    wave.addEventListener('keydown', function (e) {
      if (!man) return;
      var f = position() / man.loops[loopIdx].seconds;
      if (e.key === 'ArrowRight') { e.preventDefault(); seek(f + 0.05); } else if (e.key === 'ArrowLeft') { e.preventDefault(); seek(f - 0.05); }
    });
    window.addEventListener('resize', drawWave);
  }

  // ---------- controls ----------
  root.querySelector('.dt-playbtn').addEventListener('click', function () {
    root.dataset.touched = '1';
    playing ? pause() : play();
  });
  if (matchBox) matchBox.addEventListener('change', mix);
  if (extraBox) extraBox.addEventListener('change', function () { setExtra(extraBox.checked); });

  var grid = document.querySelector('[data-dt-flav-grid]');   // "four flavors" cards below the player
  function syncPills() {
    root.querySelectorAll('[data-dt-flavors] .dt-pill').forEach(function (x) {
      x.classList.toggle('on', x.getAttribute('data-flavor') === flavor);
    });
    if (grid) grid.querySelectorAll('.dt-flav[data-flavor]').forEach(function (c) {
      var on = c.getAttribute('data-flavor') === flavor;
      c.querySelector('.dt-pill').classList.toggle('on', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function selectFlavor(name) {
    if (name === flavor) return;
    swap(function () { flavor = name; }, true);
    face.setFlavor(FACE_NAMES.indexOf(name));
    syncPills();
  }
  function buildControls() {
    var have = FACE_NAMES.map(function (n) { return man.flavors.indexOf(n) >= 0; });
    face.setEnabled(have);
    // no EXTRA stems in the manifest (older render): the ring stays drawn but inert, the switch hides
    var hasExtra = man.loops.every(function (L) { return L.extra && man.flavors.every(function (f) { return L.extra[f]; }); });
    face.setExtraOk(hasExtra);
    if (extraBox && !hasExtra) extraBox.closest('label').style.display = 'none';
    flavor = man.flavors[0];
    face.setFlavor(FACE_NAMES.indexOf(flavor));
    root.querySelectorAll('[data-dt-flavors] .dt-pill').forEach(function (b) {
      var name = b.getAttribute('data-flavor');
      if (man.flavors.indexOf(name) < 0) { b.disabled = true; return; }
      b.addEventListener('click', function () { selectFlavor(name); });
    });
    // flavor cards: click (or Enter/Space) = switch the player to that flavor and play it
    var starting = false;
    if (grid) grid.querySelectorAll('.dt-flav[data-flavor]').forEach(function (c) {
      var name = c.getAttribute('data-flavor');
      if (man.flavors.indexOf(name) < 0) { c.setAttribute('aria-disabled', 'true'); return; }
      function go() {
        selectFlavor(name);
        root.dataset.touched = '1';
        if (!playing && !starting) { starting = true; play().then(function () { starting = false; }); }
        var r = root.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
        if (r.top < 0 || r.bottom > vh) {   // not fully on screen: bring the player up
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        }
      }
      c.addEventListener('click', go);
      c.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); go(); }
      });
    });
    syncPills();

    var lWrap = root.querySelector('[data-dt-loops]');
    man.loops.forEach(function (L, i) {
      var c = document.createElement('button');
      c.type = 'button'; c.className = 'dt-chip' + (i === 0 ? ' on' : ''); c.textContent = L.label;
      c.addEventListener('click', function () {
        if (i === loopIdx) return;
        swap(function () { loopIdx = i; }, false);
        lWrap.querySelectorAll('.dt-chip').forEach(function (x) { x.classList.toggle('on', x === c); });
      });
      lWrap.appendChild(c);
    });
  }

  // read-only state for testing from the console
  root._dt = function () {
    var pk = 0;
    if (analyser) { var d = new Float32Array(analyser.fftSize); analyser.getFloatTimeDomainData(d); for (var i = 0; i < d.length; i++) pk = Math.max(pk, Math.abs(d[i])); }
    return { ctx: ctx && ctx.state, time: ctx && ctx.currentTime, playing: playing, flavor: flavor, loop: loopIdx, t: t, bypass: bypass, extra: extra,
             gains: voices.map(function (v) { return +v.gain.gain.value.toFixed(3); }),
             files: filesFor(loopIdx, flavor), peak: pk };
  };

  fetch(url('manifest.json')).then(function (r) { return r.json(); }).then(function (m) {
    man = m; buildControls(); drawWave();
    if (root._snapHero) { if (document.readyState === 'complete') root._snapHero(); else addEventListener('load', root._snapHero); }
  }).catch(function () { loading.textContent = 'demo audio unavailable'; loading.classList.add('on'); });

  // ---------- hero -> player (Yoni: the plugin showed twice): the hero's plugin picture flies down into the player as
  //            you scroll and lands exactly on the live face, which only shows once it has landed ----------
  (function () {
    var shot = document.querySelector('.dt-hero-shot img'), holder = shot && shot.parentNode, gui = root.querySelector('.dt-gui');
    if (!shot || !gui) return;
    // the picture = a snapshot of the live face (same logo, same toast), once its images have loaded
    var snapped = false;
    root._snapHero = function () {   // called once the loops are in (all flavors enabled on the face)
      if (snapped) return;
      setTimeout(function () { try { shot.src = gui.toDataURL('image/png'); snapped = true; } catch (e) {} }, 400);
    };
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // Two states, never in between (Yoni): UP = the picture sits in the hero; DOWN = it has glided onto the player and the
    // live face took over. Scrolling past a point switches state and the glide runs on its own clock. Positions are
    // measured fresh at every switch and again whenever the layout moves (images/fonts loading), so an early scroll
    // can't lock in stale numbers.
    var DUR = 700, EASE = 'cubic-bezier(.65,0,.35,1)', state = '', landTimer = 0, queued = false;
    var lh = root.parentNode.querySelector('.dt-lh');
    function delta() {
      var a = holder.getBoundingClientRect(), b = gui.getBoundingClientRect();
      if (!a.width || !b.width) return null;
      return { dx: (b.left + scrollX) - (a.left + scrollX), dy: (b.top + scrollY) - (a.top + scrollY), sc: b.width / a.width };
    }
    function place(down, animate) {
      shot.style.transformOrigin = '0 0';
      shot.style.transition = animate ? 'transform ' + DUR + 'ms ' + EASE + ', border-radius ' + DUR + 'ms ' + EASE : 'none';
      var d = down ? delta() : null;
      shot.style.transform = d ? 'translate(' + d.dx.toFixed(1) + 'px,' + d.dy.toFixed(1) + 'px) scale(' + d.sc.toFixed(4) + ')' : '';
      shot.style.borderRadius = down ? '0px' : '';
    }
    function frameStyle(on, animate) {   // the player's frame (playbar, switches, shadow) + the lever note
      root.style.transition = animate ? (on ? 'opacity 300ms ease ' + Math.round(DUR * 0.55) + 'ms' : 'opacity 200ms ease') : 'none';
      root.style.opacity = on ? '1' : '0';
      if (lh) { lh.style.transition = root.style.transition; lh.style.opacity = on || root.parentNode.classList.contains('dt-lh-done') ? '' : '0'; }
    }
    function setState(next, animate) {
      if (next === state) return;
      state = next; clearTimeout(landTimer);
      if (next === 'down') {
        shot.style.visibility = 'visible';
        place(true, animate); frameStyle(true, animate);
        landTimer = setTimeout(function () { if (state === 'down') { gui.style.opacity = '1'; shot.style.visibility = 'hidden'; } }, animate ? DUR : 0);
      } else {
        gui.style.opacity = '0'; shot.style.visibility = 'visible';
        place(false, animate); frameStyle(false, animate);
      }
    }
    function threshold() {   // when the player's top has come about a third of the way up the screen: the glide lands in view
      var p = root.getBoundingClientRect();
      return Math.max(80, p.top + scrollY - innerHeight * 0.7);
    }
    function frame() {
      queued = false;
      if (!delta()) return;
      var t = threshold();
      if (state !== 'down' && scrollY > t) setState('down', !!state);          // first decision (page opened mid-way): no glide
      else if (state !== 'up' && scrollY < t * 0.6) setState('up', !!state);   // hysteresis: no flicker at the line
      else if (state === 'down' && shot.style.visibility === 'hidden') place(true, false);   // layout moved: stay locked on
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(frame); } }
    function relayout() { if (state === 'down') place(true, false); queue(); }
    addEventListener('scroll', queue, { passive: true });
    addEventListener('resize', relayout);
    addEventListener('load', relayout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(relayout);
    queue();
  })();

  // ---------- trial downloads: the visitor's OS first ----------
  (function () {
    var box = document.querySelector('[data-dt-dl]'); if (!box) return;
    var win = /Windows/i.test(navigator.userAgent || '') ;
    var w = box.querySelector('[data-dt-download="win"]');
    if (win && w) box.insertBefore(w, box.firstChild);
  })();

  // ---------- phones: "email me the download link" instead of installer buttons ----------
  // iOS/Android can't run the installers (and most ad traffic is phones). UA check, not width: a narrow desktop
  // window still gets the download buttons. iPadOS reports a Mac UA, so it keeps the buttons.
  (function () {
    if (!/iPhone|iPad|iPod|Android/i.test(navigator.userAgent || '')) return;
    var form = document.querySelector('[data-dt-mail]'); if (!form) return;
    var tpl = form.cloneNode(true);
    function q(sel, el) { return (el || document).querySelector(sel); }
    function wire(f) {
      f.hidden = false;
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var inp = q('input[type=email]', f), btn = q('button', f), msg = q('.dt-mail-msg', f), hp = q('.dt-hp', f);
        var email = (inp.value || '').trim();
        msg.classList.remove('err');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { msg.textContent = "that doesn't look like an email address."; msg.classList.add('err'); inp.focus(); return; }
        btn.disabled = true; msg.textContent = 'sending...';
        fetch(f.getAttribute('data-endpoint'), { method: 'POST', headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ email: email, product: 'DT', source: f.getAttribute('data-source') || 'page', website: hp ? hp.value : '' }) })
          .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok && j.ok, j: j }; }); })
          .then(function (res) {
            if (res.ok) {
              var done = document.createElement('div'); done.className = 'dt-mail-done'; done.setAttribute('role', 'status');
              done.textContent = 'sent! check your inbox on your computer.';
              f.parentNode.replaceChild(done, f);
            } else { btn.disabled = false; msg.textContent = (res.j && res.j.error) || "couldn't send it just now. try again in a minute."; msg.classList.add('err'); }
          })
          .catch(function () { btn.disabled = false; msg.textContent = "couldn't send it just now. try again in a minute."; msg.classList.add('err'); });
      });
    }
    // trial section: the form replaces the installer buttons
    var dl = q('[data-dt-dl]'), desk = q('[data-dt-desk]'), phone = q('[data-dt-phone]');
    if (dl) dl.hidden = true;
    if (desk) desk.hidden = true;
    if (phone) phone.hidden = false;
    wire(form);
    // hero: "try it free" opens the same form right there instead of jumping to the trial section
    var link = q('.dt-hero .dt-trial-link');
    if (link) link.addEventListener('click', function (e) {
      e.preventDefault();
      var f = tpl.cloneNode(true);
      f.setAttribute('data-source', 'hero'); f.classList.add('dt-mail-hero');
      var b = q('button', f); b.className = 'dt-btn dt-btn-buy';
      link.parentNode.insertBefore(f, link.nextSibling);
      link.hidden = true;
      wire(f);
      q('input[type=email]', f).focus();
    });
  })();

  // ---------- page bar: slides in once the hero's buy button is gone ----------
  var bar = document.querySelector('.dt-bar'), hero = document.querySelector('.dt-hero');
  if (bar && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { bar.classList.toggle('show', !es[0].isIntersecting); }).observe(hero);
  }

  // ---------- scroll reveal (page-wide) ----------
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.dt-rv').forEach(function (el) { io.observe(el); });
  } else document.querySelectorAll('.dt-rv').forEach(function (el) { el.classList.add('in'); });
})();
